"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
require("../../../assets/styles/typography.scss");
require("./index.scss");
const NavBar_1 = __importDefault(require("@Components/Navigations/NavBar"));
const react_router_dom_1 = require("react-router-dom");
const Footer_1 = __importDefault(require("@Components/Navigations/Footer"));
const AlertMessage_1 = __importDefault(require("@Components/Popups/AlertMessage"));
const Preloaders_1 = __importDefault(require("@Components/Preloaders"));
const contexts_1 = require("@App/contexts");
const mobx_react_1 = require("mobx-react");
const HelmetSet_1 = require("@Components/HelmetSet");
const react_error_boundary_1 = require("react-error-boundary");
const api_client_1 = require("@App/api/api-client");
const HttpError_1 = require("@App/exceptions/HttpError");
const UserInfoHandler_1 = __importDefault(require("@Scenes/RootLayout/UserInfoHandler"));
const MLCThemeProvider_1 = __importDefault(require("@Scenes/RootLayout/MLCThemeProvider"));
const NotificationProvider_1 = __importDefault(require("@Scenes/RootLayout/NotificationProvider"));
const RootLayout = () => {
    const { preloaderStore, authStore, libStore } = (0, react_1.useContext)(contexts_1.StoresContext);
    const [initIsDone, setInitIsDone] = (0, react_1.useState)(false);
    const handleError = (0, react_error_boundary_1.useErrorHandler)();
    // Handle 503 "Maintenance" Errors From The API
    api_client_1.axiosClient.interceptors.response.use(undefined, (error) => {
        const res = error.response;
        if ((res === null || res === void 0 ? void 0 : res.status) === 503) {
            handleError(new HttpError_1.HttpError(res.data, res.status));
        }
        return Promise.reject(error);
    });
    const initFunc = () => __awaiter(void 0, void 0, void 0, function* () {
        preloaderStore.openMainPreloader(true);
        try {
            yield authStore.checkUserAuthorized();
        }
        catch (ignore) {
            authStore.clearLoginData();
        }
        yield Promise.all([
            libStore.loadLanguages(),
            libStore.loadCountries(),
            libStore.loadWriterRoles(),
            libStore.loadAkaTitleTypes(),
        ]).catch((error) => {
            preloaderStore.openMainPreloader(false);
            handleError(error);
        });
        preloaderStore.openMainPreloader(false);
        setInitIsDone(true);
    });
    (0, react_1.useEffect)(() => {
        initFunc().then();
    }, []);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(HelmetSet_1.HelmetSet, null),
        react_1.default.createElement(MLCThemeProvider_1.default, null,
            react_1.default.createElement("div", { className: "app" },
                initIsDone && (react_1.default.createElement(UserInfoHandler_1.default, null,
                    react_1.default.createElement(NotificationProvider_1.default, null,
                        react_1.default.createElement(NavBar_1.default, null),
                        react_1.default.createElement(react_router_dom_1.Outlet, null),
                        react_1.default.createElement(Footer_1.default, null)))),
                react_1.default.createElement(AlertMessage_1.default, null),
                react_1.default.createElement(Preloaders_1.default, null))),
        react_1.default.createElement(react_router_dom_1.ScrollRestoration, null)));
};
exports.default = (0, mobx_react_1.observer)(RootLayout);
